<template>
    <div>
        <img :src="getImgUrl('images/ui/logo-t2.jpg')" alt="" class="pc-img-l" style="float: left">
        <div style="float: left">
            <div class="welcome-pic">
<!--                <img :src="getImgUrl('images/ui/dt-6.png')" style="width: 2.6rem;"/>-->
<!--                <img :src="getImgUrl('images/ui/dt-7.png')" style="width: 4rem;"/>-->
                <span style="font-size: 0.4rem;" v-if="this.merUid&&this.merUid>0">实验动物从业人员上岗证考试</span>
                <span style="font-size: 0.4rem;" v-else>实验动物从业人员上岗证模拟考试</span>
            </div>
            <div class="logoin-1">
                <img :src="getImgUrl('images/ui/dt-4.png')" alt="">
                <input type="tel" placeholder="请输入手机号" v-model="form.phone" >
            </div>
            <div class="logoin-1">
                <img :src="getImgUrl('images/ui/dt-5.png')" alt="">
                <input type="tel" v-model="form.short_code" placeholder="请输入验证码">
                <input type="button" value="获取验证码" class="logo-yz" @click="getShortCode()" v-if="buttonSecond==61" >
                <input type="button" :value="buttonText" class="logo-yz"  v-else >
            </div>
            <a class="zhuce flex-sh col-j1 font-s14" @click="login()">登录</a>
        </div>

        <tips :show="show" :content="content" @hide-tips="closeTips"></tips>
        <div style="clear:both;"></div>
        <div style="margin-top:100px;text-align: center;">
            <span>备案号：</span><a href='https://beian.miit.gov.cn/' style='display:inline'  target='_blank'>京ICP备18054329号-2</a>
        </div>
    </div>
</template>

<script>
    export default {
        name: "Login",
        data: function () {
            return {
                show: false,
                content: "",
                form: {
                    login_type: 2,
                    phone: "",
                    short_code: ""
                },
                examId: null,
                merUid: null,
                buttonText:'60 秒',
                buttonSecond:61,
                buttonInterval:null,
            }
        },
        mounted: function () {
            document.title = "登陆";
            document.body.className = "col-b1 font-s13 flex-sh login-pc";
            window.setCss("/css/zhucedenglu.css");

            this.examId = this.$route.query.examId?this.$route.query.examId:1;
            this.merUid = this.$route.query.merUid?this.$route.query.merUid:0;
        },
        methods: {
            closeTips() {
                this.show = false;
            },
            login() {
                if (this.form.phone == '') {
                    this.content = "请输入手机号";
                    this.show = true;
                    return;
                }
                if (this.form.short_code == '') {
                    this.content = "请输入验证码";
                    this.show = true;
                    return;
                }
                if (this.examId == null || this.merUid == null) {
                    this.content = "登陆失败,请联系管理员重新获取考试链接";
                    this.show = true;
                    return;
                }
                this.$axios.post('/t/user/public/login', this.form).then(res => {
                    if (res.data.code == this.$webConfig.httpSuccessStatus) {
                        this.$ls.set(this.$webConfig.authTokenName, res.data.data);
                        this.$router.push({path: '/home/info?examId=' + this.examId + '&merUid=' + this.merUid});
                    }else{
                        this.content = res.data.message;
                        this.show = true;
                    }
                })
            },
            getImgUrl(path) {
                return process.env.BASE_URL + path;
            },
            getShortCode(){
                if (this.form.phone == '') {
                    this.content = "请输入手机号";
                    this.show = true;
                    return;
                }
                let _that = this;
                this.$axios.get("/t/user/public/sms?phone_num="+this.form.phone).then(res=>{
                    if(res.data.code != this.$webConfig.httpSuccessStatus){
                        this.content = res.data.message;
                        this.show = true;
                    }else{
                        _that.buttonSecond--;
                        this.buttonInterval = window.setInterval(function () {
                            _that.buttonSecond--;
                            _that.buttonText =_that.buttonSecond+' 秒';
                            if(_that.buttonInterval!=null && _that.buttonSecond <=0 ){
                                window.clearInterval(_that.buttonInterval);
                                _that.buttonSecond=61;
                                _that.buttonText="60 秒";
                            }
                        },1000);
                    }
                })
            }
        },
    }
</script>

<style scoped>

</style>
